var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgModeIcon = function SvgModeIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 2v-.25A.75.75 0 0 0 6.25 1h-2.5a.75.75 0 0 0-.75.75V2H0v2h3v.25c0 .412.337.75.75.75h2.5c.412 0 .75-.338.75-.75V4h9V2zM4 4V2h2v2zm9 2.75a.753.753 0 0 0-.75-.75h-2.5a.753.753 0 0 0-.75.75V7H0v2h9v.25c0 .412.338.75.75.75h2.5c.412 0 .75-.338.75-.75V9h3V7h-3zM10 9V7h2v2zm-3 2.75a.753.753 0 0 0-.75-.75h-2.5a.75.75 0 0 0-.75.75V12H0v2h3v.25c0 .412.337.75.75.75h2.5c.412 0 .75-.338.75-.75V14h9v-2H7zM4 14v-2h2v2z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgModeIcon);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;